import {
  Button,
  Input,
  Divider,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Icon,
  Spin
  // Message
} from 'iview'
const IviewComps = [
  Button,
  Input,
  Divider,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Icon,
  Spin
]

export default {
  install (Vue) {
    IviewComps.forEach(comp => {
      Vue.component(comp.name, comp)
    })
    Vue.prototype.$Spin = window.$Spin = {
      show: () => {
        return Spin.show({
          render: (h) => {
            return h("div", [
              h("Icon", {
                class: "ivu-spin-icon-load",
                props: {
                  type: "ios-loading",
                  size: 18
                }
              })
            ])
          }
        })
      },
      hide: Spin.hide
    }
  }
}